<script>
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import FormCreator from '../../UI/Form/FormCreator.vue'
import FieldCreator from '../../UI/Form/FieldCreator.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  components: { ButtonAll, FieldCreator, FormCreator, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    simulation: { type: Object, default: {} },
    simulationId: { type: Number, default: '' },
    def: { type: Object, default: {} },
    isVisible: { type: Boolean, default: false },
  },

  data() {
    return {
      fields: [],
      formData: null,
    }
  },

  watch: {
    isVisible: {
      handler() {
        this.$refs.modal.open()
      },
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    sendFees: function () {
      let value = this.$refs.feesField.datas

      value.finance = {
        applicationFee: value['finance.applicationFee'],
      }
      if (value.finance.applicationFee < 0) {
        alert(this.$t('simulation.popin.fees.error.shouldPositive'))
        return
      }

      this.patchJSON('quotations/' + this.simulationId, value, {}).then((json) => {
        $('#modal-fees').modal('hide')
        this.simulation.finance.applicationFee = value.finance.applicationFee
      })
    },
  },
}
</script>
<template>
  <ModalDialog
    ref="modal"
    id="modal-fees"
    id-modal-page="proposalbox"
    class-modal-dialog="modal-lg"
    title-t="simulation.popin.fees.title"
    e2e-modal="fees"
  >
    <template #body>
      <h5 class="text-center mt-3">{{ $t('simulation.popin.fees.message') }}</h5>
      <FormCreator
        @update-data="updateData"
        ref="feesField"
        src-error="acceptedField"
        endpoint="quotations"
        method="patch"
        :id="simulationId"
        :config-def="def"
        :config-object="simulation"
        dynamic
        :params="{ simulationId: simulationId }"
        class-to-add="d-none"
      ></FormCreator>
      <FieldCreator
        v-if="formData !== null"
        :form-data="formData"
        name="finance.applicationFee"
        form-ref="feesField"
        domain="simulation"
        label-top
      ></FieldCreator>
    </template>
    <template #footer>
      <ButtonAll margin="no" type="information" data-dismiss="modal" label="button.cancel" e2e-button="cancelFees" />
      <ButtonAll
        margin="no"
        type="validation"
        label="simulation.popin.fees.send"
        e2e-button="sendFees"
        @click="sendFees"
      />
    </template>
  </ModalDialog>
</template>
